import {EventItem} from "../event-item";
import {Money} from "../money";
import {RegistrationStatus} from "../race-registration/registration-status";
import {AmountStatus} from "../race-registration/amount-status";
import {PaymentStatus} from "../wspay/wspay-confirmation";
import {ImportMatchType} from "./import-match-type";

export class StatementImportItem {
  id?: number;
  registrationId?: number;
  registrationStatus?: RegistrationStatus;
  paymentCode?: string;
  amount?: Money;
  referenceId?: string;
  paymentDesc?: string;
  payerName?: string;
  payerAddresLine1?: string;
  payerAddresLine2?: string;
  payerAddresLine3?: string;
  payerIban?: string;
  payerCountryCode?: string;
  amountStatus?: AmountStatus;
  event?: EventItem;
  orderId?: number;
  paymentStatus?: PaymentStatus;
  traceyPayment?: boolean;
  note?: string; //description for e.g. why it is connected manually
  importMatchType?: ImportMatchType;
}
